export const LOAD_SINGLE_SIDEBAR_RESUME_SUCCESS = 'LOAD_SINGLE_SIDEBAR_RESUME_SUCCESS';
export const LOAD_SINGLE_SIDEBAR_RESUME_START = 'LOAD_SINGLE_SIDEBAR_RESUME_START';
export const PIN_SIDEBAR_RESUME = 'PIN_SIDEBAR_RESUME';
export const UNPIN_SIDEBAR_RESUME = 'UNPIN_SIDEBAR_RESUME';
export const FLAG_SIDEBAR_RESUME = 'FLAG_SIDEBAR_RESUME';
export const UNFLAG_SIDEBAR_RESUME = 'UNFLAG_SIDEBAR_RESUME';
export const ENGAGE_SIDEBAR_RESUME = 'ENGAGE_SIDEBAR_RESUME';